import { useContext } from 'react';
import FeatureFlagsContext from './context';
import { FeatureFlags } from './type';

export default function useFeatureFlags(): FeatureFlags {
  return useContext(FeatureFlagsContext) || {};
}
